<template>
<div>
  <el-dialog
    :title="title"
    :close-on-click-modal="false"
     v-dialogDrag
    :visible.sync="visible">
    <el-form :model="inputForm" size="small" ref="inputForm" v-loading="loading" :class="method==='view'?'readonly':''"  :disabled="method==='view'"
             label-width="120px">
      <el-row  :gutter="15">
        <el-col :span="12">
            <el-form-item label="布局片块标题中文" prop="titleCn"
                :rules="[
                  {required: true, message:'布局片块标题中文不能为空', trigger:'blur'}
                 ]">
              <el-input v-model="inputForm.titleCn" placeholder="请填写布局片块标题中文"     ></el-input>
           </el-form-item>
        </el-col>
        <el-col :span="12">
            <el-form-item label="布局片块标题英文" prop="titleEn"
                :rules="[
                  {required: true, message:'布局片块标题英文不能为空', trigger:'blur'}
                 ]">
              <el-input v-model="inputForm.titleEn" placeholder="请填写布局片块标题英文"     ></el-input>
           </el-form-item>
        </el-col>
        <el-col :span="12">
            <el-form-item label="x坐标" prop="xCoordinate"
                :rules="[
                  {required: true, message:'x坐标不能为空', trigger:'blur'}
                 ]">
              <el-input v-model="inputForm.xCoordinate" placeholder="请填写x坐标"     ></el-input>
           </el-form-item>
        </el-col>
        <el-col :span="12">
            <el-form-item label="y坐标" prop="yCoordinate"
                :rules="[
                  {required: true, message:'y坐标不能为空', trigger:'blur'}
                 ]">
              <el-input v-model="inputForm.yCoordinate" placeholder="请填写y坐标"     ></el-input>
           </el-form-item>
        </el-col>
        <el-col :span="12">
            <el-form-item label="布局片块图片id" prop="blockImageId"
                :rules="[
                  {required: true, message:'布局片块图片id不能为空', trigger:'blur'}
                 ]">
              <el-input v-model="inputForm.blockImageId" placeholder="请填写布局片块图片id"     ></el-input>
           </el-form-item>
        </el-col>
        <el-col :span="12">
            <el-form-item label="布局片块描述中文" prop="descriptionCn"
                :rules="[
                  {required: true, message:'布局片块描述中文不能为空', trigger:'blur'}
                 ]">
          <el-input type="textarea" v-model="inputForm.descriptionCn" placeholder="请填写布局片块描述中文"     ></el-input>
           </el-form-item>
        </el-col>
        <el-col :span="12">
            <el-form-item label="布局片块描述英文" prop="descriptionEn"
                :rules="[
                  {required: true, message:'布局片块描述英文不能为空', trigger:'blur'}
                 ]">
          <el-input type="textarea" v-model="inputForm.descriptionEn" placeholder="请填写布局片块描述英文"     ></el-input>
           </el-form-item>
        </el-col>
        <el-col :span="12">
            <el-form-item label="关联产品图册id" prop="portfolioId"
                :rules="[
                  {required: true, message:'关联产品图册id不能为空', trigger:'blur'}
                 ]">
              <el-input v-model="inputForm.portfolioId" placeholder="请填写关联产品图册id"     ></el-input>
           </el-form-item>
        </el-col>
        </el-row>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button size="small" @click="visible = false">关闭</el-button>
      <el-button size="small" type="primary" v-if="method != 'view'" @click="doSubmit()" v-noMoreClick>确定</el-button>
    </span>
  </el-dialog>
</div>
</template>

<script>
  import cecUnmPortfolioPointService from '@/api/cecunmportfoliopoint/cecUnmPortfolioPointService'
  export default {
    data () {
      return {
        title: '',
        method: '',
        visible: false,
        loading: false,
        inputForm: {
          id: '',
          titleCn: '',
          titleEn: '',
          xCoordinate: '',
          yCoordinate: '',
          blockImageId: '',
          descriptionCn: '',
          descriptionEn: '',
          portfolioId: ''
        }
      }
    },
    components: {
    },
    methods: {
      init (method, id) {
        this.method = method
        this.inputForm.id = id
        if (method === 'add') {
          this.title = `新建设计后片块描点`
        } else if (method === 'edit') {
          this.title = '修改设计后片块描点'
        } else if (method === 'view') {
          this.title = '查看设计后片块描点'
        }
        this.visible = true
        this.loading = false
        this.$nextTick(() => {
          this.$refs.inputForm.resetFields()
          if (method === 'edit' || method === 'view') { // 修改或者查看
            this.loading = true
            cecUnmPortfolioPointService.queryById(this.inputForm.id).then(({data}) => {
              this.inputForm = this.recover(this.inputForm, data)
              this.loading = false
            })
          }
        })
      },
      // 表单提交
      doSubmit () {
        this.$refs['inputForm'].validate((valid) => {
          if (valid) {
            this.loading = true
            cecUnmPortfolioPointService.save(this.inputForm).then(({data}) => {
              this.visible = false
              this.$message.success(data)
              this.$emit('refreshDataList')
              this.loading = false
            }).catch(() => {
              this.loading = false
            })
          }
        })
      }
    }
  }
</script>

  
